import { Metadata } from 'next'

const metadata: Metadata = {
  title: 'What You Can Ship with ShipSkis | Skis, Snowboards & Luggage',
  description:
    'Discover everything you can ship with ShipSkis — from skis and ' +
    'snowboards to luggage and more. Learn how easy it is to send your gear anywhere in the world.',
  alternates: {
    canonical: 'https://www.shipskis.com/what-can-i-ship',
  },
}

export default metadata
